import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const items = ['Buscar ejercicios que no están adaptados al trimestre de tu alumna', 'No saber qué hacer si aparece un síntoma que no esperabas en plena clase', 'No tener documentación que te respalde si algo sale mal', 'Querer derivar al médico y no saber cómo comunicarte con él', 'Perder a la alumna en la semana 40 cuando recién arrancaba la confianza'];
  return <section className="py-16 md:py-24 px-4 bg-white border-y border-slate-200" data-id="element-248">
      <div className="max-w-4xl mx-auto" data-id="element-249">
        {/* PAIN INTRO */}
        <div className="text-center mb-10 md:mb-14" data-id="element-250">
          <p className="text-red-500 font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-251">
            😤 La Realidad
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto text-slate-900" data-id="element-252">
            ¿Cuántas veces más vas a improvisar con una{' '}
            <span className="text-primary" data-id="element-253">embarazada delante tuyo?</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600 leading-relaxed max-w-3xl mx-auto mb-8 font-medium" data-id="element-254">
            Amás lo que hacés. Pero nadie te preparó para esto:
          </p>
        </div>

        {/* PAIN POINTS VISUAL */}
        <div className="mb-10" data-id="element-255">
          <div className="grid sm:grid-cols-2 gap-3 md:gap-4" data-id="element-256">
            {items.map((item, i) => <div key={i} className="bg-slate-50 border border-slate-200 rounded-xl p-4 md:p-5 flex items-start gap-3 hover:border-red-500/30 transition-colors" data-id="element-257">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 shrink-0 mt-0.5" data-id="element-258" />
                <span className="text-slate-700 text-sm md:text-base font-medium" data-id="element-259">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* GOLPE DE MENSAJE */}
        <div className="text-center bg-slate-50 border border-primary/20 rounded-2xl p-6 md:p-8" data-id="element-260">
          <p className="text-lg md:text-2xl font-bold text-slate-700 leading-tight" data-id="element-261">
            No es falta de ganas.
            <br data-id="element-262" />
            <span className="text-primary text-xl md:text-3xl" data-id="element-263">
              Es falta de sistema.
            </span>
          </p>
        </div>
      </div>
    </section>;
}